import { Col, Row } from "reactstrap"
import DynamicDatatable from "../../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"
import { useEffect } from "react"
import GeneralBackButton from "../../../../common/AdminCommonComponents/Buttons/GeneralBackButton/GeneralBackButton"
import DynamicButton from "../../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"
import InfoCard from "../../../../common/AdminCommonComponents/InfoCard/InfoCard"
import ColoredHeader from "../../../../common/AdminCommonComponents/ColoredHeading/ColoredHeader"

const ReturnOrderDetail = () => {
  const generalInfo = [
    { label: "Order ID:", value: "#1234" },
    { label: "Return ID:", value: "#123" },
    { label: "Customer Name:", value: "Full Name" },
    { label: "Customer Phone no:", value: "03417053723" },
    { label: "Payment Status:", value: "Paid" },
    { label: "Order Date:", value: "October 4, 2024" },
    { label: "Return Request date:", value: "october 4, 2024" },
    { label: "Return Status:", value: "october 4, 2024" },
    { label: "Return Reason:", value: "october 4, 2024" },
    { label: "Seller Approval:", value: "AS Store" },
    { label: "Seller Store Name:", value: "AS Store" },
  ]

  const shippingInformation = [
    {
      label: "Shipping Address:",
      value: "Al-Noor garden Faisalabad, Faisalabad Pakistan",
    },
    { label: "Delivery Type:", value: "Standard" },
    { label: "Warehouse:", value: "Shipped" },
    { label: "Restock status:", value: "shipped" },
    { label: "courier Name:", value: "DHL express" },
    { label: "tracking iD:", value: "DHL12345678" },
    { label: "estimated delivery date:", value: "october 6, 2024" },
  ]

  const paymentInfo = [
    { label: "Price:", value: "$49.00" },
    { label: "Payment Status:", value: "+$1.00" },
    { label: "Refund Status:", value: "-$0.00" },
    { label: "Original Payment method:", value: "$50.00" },
    { label: "Refund Payment method:", value: "Credit Card" },
  ]

  const itemsTableData = [
    {
      productName: "Product name",
      productId: "#1234",
      sku: "SKU124a",
      quantity: "1",
      unitPrice: "$49.00",
    },
  ]

  const columns = [
    { name: "Product name", selector: (row) => row.productName },
    { name: "Product ID", selector: (row) => row.productId },
    { name: "SKU", selector: (row) => row.sku },
    { name: "Qty", selector: (row) => row.quantity },
    { name: "Unit Price", selector: (row) => row.unitPrice },
  ]

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="bg-white p-3 px-4 m-3 shadow">
      <GeneralBackButton />
      <div class="fw-semibold fs-4 text-center">Return order Detail</div>

      <Row className="mt-3 row-cols-1 row-cols-sm-2 row-cols-xl-3 gy-3 gy-xl-0">
        <Col>
          <InfoCard title="General Information" headerColor="#FBBD34" data={generalInfo} />
        </Col>
        <Col>
          <InfoCard title="Shipping Information" headerColor="#41B8E4" data={shippingInformation} />
        </Col>
        <Col>
          <InfoCard title="Payment Information" headerColor="#EC7426" data={paymentInfo} />
        </Col>
      </Row>

      <div className="d-flex justify-content-between gap-3">
        <div className="shadow flex-grow-1 mt-3">
          <ColoredHeader title="Product" headerColor="#9747FF" />
          <DynamicDatatable columns={columns} data={itemsTableData} type="gray" />
        </div>

        <div className="mt-3 d-flex flex-column gap-2">
          <DynamicButton theme="gray">Contact Customer</DynamicButton>
          <DynamicButton theme="yellow">Refund Process</DynamicButton>
          <DynamicButton theme="sky-blue">Approve</DynamicButton>
          <DynamicButton theme="orange">Reject</DynamicButton>
        </div>
      </div>
    </div>
  )
}

export default ReturnOrderDetail
